import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LandingShell from '@/components/landing/LandingShell';
import SEO from '@/components/common/SEO';
import AICreditManager from '@/components/billing/AICreditManager';
import { useToast } from '@/components/ui/use-toast';

export default function AICredits() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();
  const checkoutState = searchParams.get('checkout');

  useEffect(() => {
    if (!checkoutState) {
      return;
    }

    if (checkoutState === 'success') {
      toast({
        title: 'Credits added',
        description: 'Your AI credit top-up was completed successfully.',
      });
      window.dispatchEvent(new CustomEvent('mapleos:credits-refresh'));
    }

    if (checkoutState === 'cancelled') {
      toast({
        title: 'Checkout cancelled',
        description: 'No AI credits were added.',
      });
    }

    navigate('/credits', { replace: true });
  }, [checkoutState, navigate, toast]);

  return (
    <LandingShell>
      <SEO
        title="AI Credits"
        description="Manage MapleOS AI credits, top-ups, auto top-up settings, and usage history."
      />

      <div className="container mx-auto max-w-7xl px-4 py-10">
        <div className="mx-auto max-w-3xl text-center">
          <h1 className="mt-4 text-4xl font-bold tracking-tight md:text-5xl">Manage your AI credits</h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Use as much or as little as you want. Auto top-up or add credits as you need it.
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-5xl">
          <AICreditManager embedded />
        </div>
      </div>
    </LandingShell>
  );
}